import React, { useState } from "react";
import { Trans, useTranslation } from "react-i18next";
import styled from "styled-components";
import Button from "components/bootstrap/Button";
import Modal from "components/bootstrap/Modal";
import Well from "components/bootstrap/Well";
import Icon from "components/common/Icon";
import DocumentTitle from "components/common/DocumentTitle";
import { qualifyUrl } from "util/URLUtils";
import LoginChrome from "components/login/LoginChrome";
import useProductName from "brand-customization/useProductName";
import DocsHelper from "util/DocsHelper";
const StyledIcon = styled(Icon)`
  margin-left: 6px;
`;
const HelpLink = ({ children = void 0 }) => /* @__PURE__ */ React.createElement("a", { href: DocsHelper.PAGES.SERVER_UNAVAILABLE, rel: "noopener noreferrer", target: "_blank" }, children);
const ServerUnavailablePage = ({ server = void 0 }) => {
  const { t } = useTranslation("pages");
  const productName = useProductName();
  const [showDetails, setShowDetails] = useState(false);
  const _toggleDetails = () => setShowDetails(!showDetails);
  const _formatErrorMessage = () => {
    if (!showDetails) {
      return null;
    }
    const noInformationMessage = /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("hr", null), /* @__PURE__ */ React.createElement("p", null, t("server_unavailable.no_information")));
    if (!(server == null ? void 0 : server.error)) {
      return noInformationMessage;
    }
    const { error } = server;
    const errorDetails = [];
    if (error.message) {
      errorDetails.push(
        /* @__PURE__ */ React.createElement("dt", { key: "error-title" }, t("server_unavailable.error_message")),
        /* @__PURE__ */ React.createElement("dd", { key: "error-desc" }, error.message)
      );
    }
    if (error.originalError) {
      const { originalError } = error;
      errorDetails.push(
        /* @__PURE__ */ React.createElement("dt", { key: "status-original-request-title" }, t("server_unavailable.original_request")),
        /* @__PURE__ */ React.createElement("dd", { key: "status-original-request-content" }, String(originalError.method), " ", String(originalError.url))
      );
      errorDetails.push(
        /* @__PURE__ */ React.createElement("dt", { key: "status-code-title" }, t("server_unavailable.status_code")),
        /* @__PURE__ */ React.createElement("dd", { key: "status-code-desc" }, String(originalError.status))
      );
      if (typeof originalError.toString === "function") {
        errorDetails.push(
          /* @__PURE__ */ React.createElement("dt", { key: "full-error-title" }, t("server_unavailable.full_error_message")),
          /* @__PURE__ */ React.createElement("dd", { key: "full-error-desc" }, originalError.toString())
        );
      }
    }
    if (errorDetails.length === 0) {
      return noInformationMessage;
    }
    return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("hr", { style: { marginTop: 10, marginBottom: 10 } }), /* @__PURE__ */ React.createElement("p", null, t("server_unavailable.last_response")), /* @__PURE__ */ React.createElement(Well, { bsSize: "small", style: { whiteSpace: "pre-line" } }, /* @__PURE__ */ React.createElement("dl", { style: { marginBottom: 0 } }, errorDetails)));
  };
  const modalTitle = t("server_unavailable.modal_title");
  return /* @__PURE__ */ React.createElement(DocumentTitle, { title: t("server_unavailable.document_title") }, /* @__PURE__ */ React.createElement(LoginChrome, null, /* @__PURE__ */ React.createElement(Modal, { show: true, onHide: () => {
  } }, /* @__PURE__ */ React.createElement(Modal.Header, null, /* @__PURE__ */ React.createElement(Modal.Title, null, /* @__PURE__ */ React.createElement(Icon, { name: "warning" }), " ", modalTitle)), /* @__PURE__ */ React.createElement(Modal.Body, null, /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("p", null, /* @__PURE__ */ React.createElement(
    Trans,
    {
      t,
      i18nKey: "server_unavailable.intro",
      values: { productName, address: qualifyUrl("") },
      components: { serverAddress: /* @__PURE__ */ React.createElement("i", null) }
    }
  )), /* @__PURE__ */ React.createElement("p", null, t("server_unavailable.redirect_hint")), /* @__PURE__ */ React.createElement("p", null, /* @__PURE__ */ React.createElement(Trans, { t, i18nKey: "server_unavailable.need_help", components: { helpLink: /* @__PURE__ */ React.createElement(HelpLink, null) } })), /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(Button, { bsStyle: "primary", tabIndex: 0, onClick: _toggleDetails, bsSize: "sm" }, showDetails ? t("server_unavailable.less_details") : t("server_unavailable.more_details"), /* @__PURE__ */ React.createElement(StyledIcon, { name: showDetails ? "keyboard_arrow_up" : "keyboard_arrow_down" })), _formatErrorMessage()))))));
};
export default ServerUnavailablePage;
